// src/common/components/cartModal/components/validationError/ValidationError.tsx
import React from "react";
import { MdErrorOutline, MdWarning, MdInfo, MdClose } from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./ValidationError.module.scss";

interface ValidationErrorProps {
  message: string;
  type?: "error" | "warning" | "info";
  showIcon?: boolean;
  onDismiss?: () => void;
}

const ValidationError: React.FC<ValidationErrorProps> = ({
  message,
  type: propType = "error",
  showIcon = true,
  onDismiss,
}) => {
  const { isDark } = useTheme();

  // Определяем тип ошибки по сообщению
  const getErrorType = (msg: string): "error" | "warning" | "info" => {
    if (msg.includes("бонус") || msg.includes("Неверный промокод")) {
      return "warning";
    }
    if (msg.includes("не действует") || msg.includes("нет товаров")) {
      return "info";
    }
    return propType;
  };

  const type = getErrorType(message);

  const getColors = () => {
    switch (type) {
      case "warning":
        return {
          background: isDark ? "#332E1D" : "#FFF3CD",
          border: isDark ? "#665C34" : "#FFEEBA",
          text: isDark ? "#FFD54F" : "#856404",
          icon: isDark ? "#FFD54F" : "#F0AD4E",
        };
      case "info":
        return {
          background: isDark ? "#1A3A5F" : "#D1ECF1",
          border: isDark ? "#2C5282" : "#BEE5EB",
          text: isDark ? "#63B3ED" : "#0C5460",
          icon: isDark ? "#63B3ED" : "#17A2B8",
        };
      case "error":
      default:
        return {
          background: isDark ? "#3C1E1E" : "#F8D7DA",
          border: isDark ? "#742A2A" : "#F5C6CB",
          text: isDark ? "#FC8181" : "#721C24",
          icon: isDark ? "#FC8181" : "#C53030",
        };
    }
  };

  const colors = getColors();

  const getIcon = () => {
    switch (type) {
      case "warning":
        return MdWarning;
      case "info":
        return MdInfo;
      case "error":
      default:
        return MdErrorOutline;
    }
  };

  const Icon = getIcon();

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: colors.background,
        borderColor: colors.border,
      }}
    >
      {showIcon && (
        <div className={styles.iconContainer}>
          <Icon size={20} color={colors.icon} />
        </div>
      )}

      <div className={styles.content}>
        <p className={styles.message} style={{ color: colors.text }}>
          {message}
        </p>
      </div>

      {onDismiss && (
        <button className={styles.dismissButton} onClick={onDismiss}>
          <MdClose size={20} color={colors.text} />
        </button>
      )}
    </div>
  );
};

export default ValidationError;